var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.339844,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F2F4F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6.33984,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F2F4F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7071 12.6327C13.3166 12.2422 12.6834 12.2422 12.2929 12.6327C11.9024 13.0233 11.9024 13.6564 12.2929 14.047L16.5858 18.3398L12.2929 22.6327C11.9024 23.0232 11.9024 23.6564 12.2929 24.0469C12.6834 24.4375 13.3166 24.4375 13.7071 24.0469L18 19.7541L22.2929 24.0469C22.6834 24.4375 23.3166 24.4375 23.7071 24.0469C24.0976 23.6564 24.0976 23.0232 23.7071 22.6327L19.4142 18.3398L23.7071 14.047C24.0976 13.6564 24.0976 13.0233 23.7071 12.6327C23.3166 12.2422 22.6834 12.2422 22.2929 12.6327L18 16.9256L13.7071 12.6327Z",
    fill: "#232A2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCancel);
export default __webpack_public_path__ + "static/media/CircleCancel.2fcc6e02506969e74c8652464622c9b9.svg";
export { ForwardRef as ReactComponent };